export type RuntimeConfig = {
  ASSET_SERVER: string;
  PROVIDER_DIRECTORY_SDK: string;
  GRID_LICENSE_KEY: string;
  /** PDF license secret (not the sessionStorage key name). */
  LICENSE_STORAGE_KEY: string;
  /** BFF path prefixing: 'true' | 'false' | '' (inherit). */
  USE_API_PROXY_ROUTES: string;
  /** Console log verbosity: DEBUG | INFO | WARN | ERROR | NO_LOG | '' (inherit default WARN). */
  UI_LOG_LEVEL: string;
};

export type RuntimeConfigSnapshot = RuntimeConfig;

declare global {
  interface Window {
    RUNTIME_CONFIG?: Partial<RuntimeConfig>;
    BUILD_CONFIG?: {
      GRID_LICENSE_KEY?: string;
      LICENSE_STORAGE_KEY?: string;
      DATADOG_ID?: string;
      BUILD_ID?: string;
    };
  }
}

export const DEFAULT_RUNTIME_CONFIG: RuntimeConfig = {
  ASSET_SERVER: '',
  PROVIDER_DIRECTORY_SDK: '1.5.9',
  GRID_LICENSE_KEY: '',
  LICENSE_STORAGE_KEY: '',
  USE_API_PROXY_ROUTES: '',
  UI_LOG_LEVEL: '',
};
